import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

interface ModalFooterProps {
  onClose: () => void
  onDiscoverMore: () => void
}

const ModalFooter = ({ onClose, onDiscoverMore }: ModalFooterProps) => {
  return (
    <Box flexDirection="row" gap="s8" width="full" justifyContent="flexEnd" paddingTop="s24">
      <F0Button onClick={onClose} variant="ghost" label={i18n.t('common.close')} />
      <F0Button
        onClick={onDiscoverMore}
        variant="outline"
        label={i18n.t('upsell.request_modal.error.try_again')}
      />
    </Box>
  )
}

export default ModalFooter
